var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',[_c('h1',{staticClass:"primary--text"},[_vm._v("\n        "+_vm._s(_vm.$t('page.logout.view.logout.text'))+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }